import { AlertController } from '@ionic/angular';
import { Injectable } from '@angular/core';

import { Storage } from '@ionic/storage-angular';
import { Constants } from 'app/utility/constants';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';


@Injectable({
	providedIn: 'root'
})
export class StorageService
{
	private _storage: Storage | null = null;

	constructor(
        private storage: Storage,
        private alertController: AlertController)
	{
		this.init();
	}

    alertShowing = false;
	public async init(promptToExitOnError: boolean = false)
	{
        try {
		    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
            const storage = await this.storage.create();
            this._storage = storage;
        }
        catch (error) {
            console.error("Error on storage service init: "+error);
            if (!promptToExitOnError || this.alertShowing || !Capacitor.isNativePlatform) {
                return;
            }
            this.alertShowing = true;
            const alert = await this.alertController.create({
                header: 'Error',
                message: 'Failed to initialize storage. Would you like to try exiting the app?',
                buttons: [
                    {
                        text: 'Exit App',
                        handler: () => {
                            this.alertShowing = false;
                            App.exitApp();
                        }
                    },
                    {
                        text: 'Cancel',
                        role: 'cancel',
                        handler: () => {
                            this.alertShowing = false;
                        }
                    }
                ]
            });
            await alert.present();
        }
	}

    private async formatKey(key: string): Promise<string> {
		var customerNumber = await this._storage.get(Constants.IonicStorage_CustomerNumber);
		var username = await this._storage.get(Constants.IonicStorage_Username);

		return customerNumber+"-"+username+"-"+key;
    }

	// Create and expose methods that users of this service can
	// call, for example:
    public async set(key: string, value: any, userSpecific: boolean = true): Promise<any>
    {
        try {
            if (!this._storage) {
                await this.init();
            }
            if (userSpecific) {
                key = await this.formatKey(key);
            }
            return await this._storage?.set(key, value);
        }
        catch (error) {
            console.error("Error setting value in storage: " + error);
            return null;
        }
    }

	public async get(key: string, userSpecific: boolean = true): Promise<any>
	{
        try {
            if (!this._storage) {
                await this.init();
            }
            if (userSpecific) {
                key = await this.formatKey(key);
            }
            return await this._storage?.get(key);
        } catch (error) {
            console.error("Error getting value from storage: " + error);
            return null;
        }
	}

	public async remove(key: string, userSpecific: boolean = true): Promise<any>
	{
		if (userSpecific) {
			key = await this.formatKey(key);
		}
		return this._storage?.remove(key);
	}

	public async clear() : Promise<any>
	{
		return this._storage?.clear();
	}
	public async keys(): Promise<string[]>
	{
		return this._storage.keys();
	}
}
